import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CakeCard = ({ title, image, alt, link }) => {
  return (
    <Link to={link} className="text-decoration-none">
      <Card
        className="h-100 d-flex flex-column"
        style={{ borderRadius: '15px', border: 'none', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
      >
        <Card.Header style={{ fontWeight: 'bold', fontSize: '18px', color: '#333333', padding: '20px', borderBottom: '1px solid #eeeeee' }}>
          {title}
        </Card.Header>
        <Card.Body className="px-2">
          <Card.Img variant="top" src={image} style={{ height: '100%' }} alt={alt} />
          {/* <img style={{ borderRadius: '10px' }} src={image} width="250px" height="250px" alt={alt} className="my-brand-logo" /> */}
        </Card.Body>
      </Card>
    </Link>
  );
};

export default CakeCard;
